import { computed, ref } from 'vue';

import { mappedPassengersLib } from '@/entities/passenger-with-baggages';
import type { ExtendedBaggage } from '@/entities/passenger-with-baggages';

export const useDraftBaggage = (flightBaggages: ExtendedBaggage[]) => {
  const currentBaggages = ref<ExtendedBaggage[]>(flightBaggages);

  const changeBaggagesState = (id: string) => {
    const isClickedBaggageSelected = currentBaggages.value.find(
      baggage => baggage.id === id,
    )?.isSelected;

    currentBaggages.value = currentBaggages.value.map(baggage => ({
      ...baggage,
      isSelected: baggage.id === id && !isClickedBaggageSelected,
    }));
  };

  const reset = () => (currentBaggages.value = flightBaggages);
  const unselect = () => {
    currentBaggages.value = currentBaggages.value.map(baggage => ({
      ...baggage,
      isSelected: false,
    }));
  };

  const totalPrice = computed(() =>
    mappedPassengersLib.getSelectedBaggagePrice(currentBaggages.value),
  );
  const isBaggagesSelected = computed(() =>
    currentBaggages.value.some(baggage => baggage.isSelected),
  );

  return {
    changeBaggagesState,
    currentBaggages,
    totalPrice,
    isBaggagesSelected,
    reset,
    unselect,
  };
};
